import { Injectable } from '@angular/core';
import { Product } from '../../shared/models/product.model';
import { selectorConstants } from '../../shared/constants/selector.constant';


@Injectable({
    providedIn: 'root',
})
export class ProductSelectorScrollService {
    public expandedNodeIds: Array<number> = [];
    constructor() { }

    public loadNodesOnScrollDown(event: any, products: Array<Product>): void {
        const clientHeight = event.target.scrollHeight - (event.target.clientHeight + selectorConstants.ADDITIONAL_SCROLL_HEIGHT);
        if (Math.round(event.target.scrollTop) >= Math.round(clientHeight)) {
            this.expandProductNodes(products);
        }
    }

    public expandProductNodes(products: Array<Product>): void {
        const fetchProductNodes = products.filter(product => !this.expandedNodeIds.includes(product?.id)).slice(selectorConstants.NODES_OFFSET_VALUE, selectorConstants.FETCH_NODES_COUNT);
        const notExpandedNodeIds = [...new Set(fetchProductNodes.map(obj => obj?.id))];
        if (notExpandedNodeIds?.length > 0) {
            this.expandTreeNodes(notExpandedNodeIds, true);
        }
    }

    public expandTreeNodes(nodeIdsToBeExpand: Array<any>, isProduct: boolean): void {
        this.dispatchEvent(nodeIdsToBeExpand, selectorConstants.EXPAND_ALL_TREE_NODES_EVENT);
        if (isProduct) {
            this.expandedNodeIds.push(...nodeIdsToBeExpand);
        }
    }

    public dispatchEvent(field: any, eventName: string): void {
        document.dispatchEvent(
            new CustomEvent(eventName, {
                bubbles: true,
                cancelable: true,
                detail: field,
            })
        );
    }
}
